import React, { Fragment, memo } from 'react';

const Component = ({ tariffs, hostname }) => {
    const divs = [];
    let jsons = '';

    tariffs.forEach(element => {
        const name = element.tariff_name;
        const description = element.description.meta_description;
        const sku = element.description.alias;
        const url = `https://${hostname}/internet/${element.description.alias}`;
        const price = element.price;

        divs.push((
            <div itemScope itemType='http://schema.org/Product' key={element.id}>
                <meta itemProp='name' content={`Тариф интернета ${name}`}/>
                <meta itemProp='brand' content='Дом.ру'/>
                <meta itemProp='sku' content={`internet ${sku}`}/>
                <meta itemProp='image' content='/static/images/domru.svg'/>
                <div itemProp='offers' itemScope itemType='http://schema.org/Offer'>
                    <meta itemProp='url' content={url}/>
                    <meta itemProp='price' content={price}/>
                    <meta itemProp='priceCurrency' content='RUB'/>
                    <link itemProp='availability' href='http://schema.org/InStock'/>
                </div>
                <meta itemProp='description' content={description}/>
            </div>
        ));

        jsons += `
            {
                "@context": "http://schema.org/",
                "@type": "Product",
                "brand": "Дом.ру",
                "name": "Тариф интернета ${name}",
                "description": "${description}",
                "sku": "internet ${sku}",
                "image": "/static/images/domru.svg",
                "offers": {
                    "@type": "Offer",
                    "url": "${url}",
                    "availability": "http://schema.org/InStock",
                    "priceCurrency": "RUB",
                    "price": "${price}"
                }
            },
        `;
    });


    return (
        <Fragment>
            {divs}
            <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: jsons }} />
        </Fragment>
    );
};

export default memo(Component);
